import { ApolloError } from "@apollo/client";
import ArrowBack from "@mui/icons-material/ArrowBack";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { Link } from "react-router-dom";

/** First load, before there is anything to render. */
export function WorkDetailLoading() {
  return (
    <Box sx={{ p: 6, display: "flex", justifyContent: "center" }}>
      <CircularProgress />
    </Box>
  );
}

/** The deliverable could not be read — offer the way back to the queue. */
export function WorkDetailError({ error }: { error?: ApolloError }) {
  return (
    <Box sx={{ p: 3 }}>
      <Typography color="error">
        Couldn&apos;t load this deliverable{error ? `: ${error.message}` : ""}.
      </Typography>
      <Button component={Link} to="/staff/work" startIcon={<ArrowBack />} sx={{ mt: 1 }}>
        Back to the queue
      </Button>
    </Box>
  );
}
